import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";

import NotFoundPage from "../../../StoreComponents/NotFoundPage";
import { API } from "../../../StoreComponents/conflict";

const fetcher = (url) => API.get(url).then((res) => res.data.data);
const ProjectAssetViewById = () => {
  const { asset_id } = useParams();
  // console.log(req_id);
  const navigate = useNavigate();
  // get assetSlip Data
  const {
    data: assetSlip,
    error,
    mutate,
  } = useSWR(
    asset_id ? `store/products/project/asset/viewById/${asset_id}` : null,
    fetcher
  );
  console.log(assetSlip);

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Helmet>
        <title>Product Asset Details - BBA STORE</title>
        <meta name="description" content="Product Asset Details - BBA STORE" />
      </Helmet>
      {!assetSlip ? (
        <NotFoundPage />
      ) : (
        <div className="page-wrapper">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate(-1)}
                className="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i className="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div>
              <button
                onClick={handlePrint}
                type="button"
                className="btn btn-color px-3 printBtn show ms-auto my-3 me-2 "
              >
                <i className="fa fa-print"></i>
                <span> Print</span>
              </button>
            </div>
          </div>

          <section ref={componentRef} className=" mx-3 py-4 ">
            <div className="my-5">
              {assetSlip && (
                <>
                  <div className="text-center mt-3">
                    <h4>
                        <b>INFOTECH IT SOLUTIONS</b>
                    </h4>
                   
                  </div>

                  <div className=" px-2 mt-5 py-4 d-flex justify-content-between">
                    <div>
                      <h4 className="mb-3">
                        Project: {assetSlip[0].PROJECT_NAME}
                      </h4>
                      <h4 className="mb-3">Subject: {assetSlip[0].SUBJECT}</h4>
                    </div>
                    <div>
                      <h4>Date: {assetSlip[0].RECEIVE_DATE.split("T")[0]}</h4>
                    </div>
                  </div>
                </>
              )}

              <div className="px-2 my-5">
                <table className="table ">
                  <thead>
                    <tr>
                      <th className="fw-bold col-design">SL No</th>
                      <th className="fw-bold col-design">Item Description</th>
                      <th className="fw-bold col-design">Qty/Pcs</th>
                      <th className="fw-bold col-design">Remark /Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assetSlip &&
                      assetSlip?.map((product, index) => (
                        <tr key={index}>
                          <td className="col-design">{++index}</td>
                          <td className="col-design text-start">
                            {product.PRODUCT_NAME}
                          </td>
                          <td className="col-design">{product.PRODUCT_QTY}</td>
                          <td className="col-design  text-start">
                            {product.REMARKS}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className=" px-2 py-5 row mt-5">
                  <div className="col-4 col-md-4 col-lg-4">
                    <h5 className="text-start">
                      <span className="fw-bold">স্টোর কিপার</span>
                    </h5>
                  </div>
                  <div className="col-4 col-md-4 col-lg-4 text-center ">
                    <h5>
                      <span className="fw-bold">স্টোর অফিসার</span>
                    </h5>
                  </div>
                  <div className="col-4 col-md-4 col-lg-4 text-end">
                    <h5 className="text-end">
                      <span className="fw-bold">সহকারী পরিচালক (প্রঃ)</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default ProjectAssetViewById;
